module.exports = __webpack_public_path__ + "media/stylesheets/images/star-rating/star-full-59bcde816aa594b9d874e7f3559873b1.svg";